module.exports = __webpack_public_path__ + "static/gather-6e6acf78134ec77786ba9308e97def55.png";